import { Outlet } from 'react-router-dom';
import { pluginSettingsVar } from '../../apollo/store';
import { useProvideSessionOrRedirectEffect } from 'hooks/useProvideSessionOrRedirectEffect';
import { ServiceNotAvailableError } from 'components/content/error/ServiceNotAvailableError';
import { LoadingContainer } from 'components/content/LoadingContainer/LoadingContainer';

export const ProvideSessionFttx = () => {
    const pluginSettings = pluginSettingsVar();
    const { loading, called, error } = useProvideSessionOrRedirectEffect(pluginSettings);

    if (!called || loading) {
        return <LoadingContainer />;
    }

    if (error) {
        return <ServiceNotAvailableError />;
    }

    return <Outlet />;
};
